/**
 * Shared constants and utilities for ABR filter components.
 */

import { FilterOperator } from '@moderation/domain/AbrFilter';

export const MODIFIER_OPTIONS = [
  { label: 'AND — all labels must match', value: FilterOperator.And },
  { label: 'OR — any label must match', value: FilterOperator.Or },
];

/** Runtime type guard for FilterOperator enum values. */
export function isFilterOperator(value: unknown): value is FilterOperator {
  return value === FilterOperator.And || value === FilterOperator.Or;
}
